import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectReplayEventFeatures } from '@redux/replay/replay.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

import { eventLayer } from './event.layer';

function EventLayer() {
  const replayEventFeatures = useSelectorWithReplayMode(selectReplayEventFeatures);

  if (!isFeatureCollection(replayEventFeatures)) return null;

  return (
    <Source id={SourceNameEnum.EVENTS} type="geojson" data={replayEventFeatures}>
      <Layer {...eventLayer} />
    </Source>
  );
}

export default EventLayer;
